import { useCallback, useEffect, useState } from 'react'

interface Props {
  fn: () => void
  duration: number
  condition?: boolean
}

export default function useIntervalFn({ fn, duration, condition = true }: Props) {
  const [timeoutId, setTimeoutId] = useState<any>()

  const start = useCallback(() => {
    if (condition) {
      const id = setTimeout(() => {
        fn()

        return start()
      }, duration)

      setTimeoutId(id)
    }
  }, [])

  const clear = useCallback(() => {
    clearTimeout(timeoutId)
  }, [timeoutId])

  useEffect(() => {
    if (!timeoutId) {
      start()
    }

    return clear
  }, [clear])

  return { start, clear, timeoutId }
}
